export function profileLink(method: string, profile: string): string | null {
  const p = profile.replace(/^@/, '').trim();
  if (method === 'instagram') return `https://instagram.com/${p}`;
  if (method === 'facebook') return `https://facebook.com/${p}`;
  if (method === 'email') return `mailto:${profile.trim()}`;
  if (method === 'phone') return `tel:${profile.trim()}`;
  return null;
}
